import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FullstoryServiceMock {
  public fs = {
    init: () => ({}),
    identify: () => ({}),
  };
  public initialized() {
    return;
  }
  // Mirror FullstoryService's wrappers so callers can hold either.
  public init(_options?: {
    orgId: string;
    devMode?: boolean;
    debug?: boolean;
  }): void {
    return;
  }
  public identify(_uid?: string, _userVars?: object): void {
    return;
  }
  public setVars(_scope?: 'page', _properties?: object): void {
    return;
  }
}
